import { POLICY_CONDITION_MODEL } from '../../../OvertimePolicies/Global/CreateUpdatePolicy/Model/Model';

/**
 * Builds the breakdown payload of an overtime line, adding the group level
 * snapshots the modal needs. Bonus lines have no attendance entries but still
 * open the modal to show their bonus scope.
 * @param {Object} item - Overtime line.
 * @param {Object} group - Payroll period the line belongs to.
 * @returns {Object|undefined} Breakdown payload, or undefined when there is nothing to show.
 */
export const getOvertimeBreakdown = (item, group) => {
    const isBonus = item?.policyConditionSnapshot === POLICY_CONDITION_MODEL.BONUS.key;

    return item?.items?.length || isBonus
        ? {
            ...item,
            groupConflictResolutionSnapshot: group?.groupConflictResolutionSnapshot,
            groupStackMethodSnapshot: group?.groupStackMethodSnapshot,
            hourlyRate: group?.hourlyRate,
        }
        : undefined;
};

export const PAYROLL_DETAIL_TABS = {
    ACTIVE_PERIOD: 'active_period',
    HISTORY: 'history',
};

export const PAYROLL_USER_DETAILS_TABS = [
    { key: PAYROLL_DETAIL_TABS.ACTIVE_PERIOD, trans: 'active_period' },
    { key: PAYROLL_DETAIL_TABS.HISTORY, trans: 'history' },
];

export const PAYROLL_USER_MODEL = {
    fullName: '',
    employeeId: '',
    departmentName: '',
    startDate: null,
    endDate: null,
    roleName: '',
    hourlyRate: null,
    set: function (data){
        return {
            ...this,
            fullName: data?.user?.fullName,
            employeeId: data?.employee?.employeeId,
            departmentName: data?.employee?.departmentName,
            startDate: data?.employee?.startDate,
            endDate: data?.employee?.endDate,
            roleName: data?.employee?.roleName,
            hourlyRate: data?.employee?.hourlyRate,
        }
    }
}
